//external
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
//internal
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
import { getUserGroups, getAllows } from 'services/userGroup/service';
import TableAction from 'components/v2/tableAction';
import DataTableReact from 'components/v2/dataTableReact';
import { FilterUserGroup } from '..';
import DataTableLoading from 'components/DataTableLoading';
//style
import { IconContainer } from 'pages/nutrient/list/styled';

export default function UserGroup() {
  const message = useSelector(state => state.message.data);
  const [reload, setReload] = useState(0);
  const [dataUserGroup, setDataUserGroup] = useState();
  const [allows, setAllows] = useState({});
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState();

  const { filter, setFilter } = useContext(FilterUserGroup);

  const dispatch = useDispatch();

  const columns = [
    {
      name: 'Descrição',
      selector: 'description',
      sortable: true,
    },
    {
      style: {justifyContent: "flex-end"},
      cell: row => 
        <div>
          <IconContainer>
            <TableAction 
            key="edit"
            title={"Editar"} 
            disabled={!allows.put} 
            to={`/user_group/edit/${row.id}`}>
              <EditIcon/>
            </TableAction>
            <TableAction 
            key="delete"
            title={"Excluir"} 
            disabled={!allows.delete} 
            to={`/user_group/delete/${row.id}`}>
              <DeleteIcon/>
            </TableAction>
          </IconContainer>
        </div>
    }
  ]

  const actions = [
    <div style={{display: 'flex'}} key='actionsUserGroup'>
      <TableAction 
      title={"Adicionar"} 
      disabled={!allows.post} 
      to='/user_group/add'>
        <AddIcon/>
      </TableAction>
      <TableAction 
      title={"Atualizar"} 
      onClick={refreshHandler}
      isLink={false}>
        <RefreshIcon/>
      </TableAction>
    </div>
  ];

  useEffect(() => {
    dispatch(startRequest());
    getUserGroups(perPage, filter.page, sort).then(data => {
      setTotalRows(parseInt(data.headers['recordcount']));
      setDataUserGroup(data.data);
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
    dispatch(startRequest());
    getAllows().then(data => {
      setAllows(data.data)
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }, [dispatch, reload, perPage, filter, sort]);

  function refreshHandler() {
    setReload(reload + 1);
  }

  const handlePerRowsChange = (perPage) => {
    setPerPage(perPage);
  };

  const handlePageChange = (page) => {
    setFilter({...filter, page});
  };

  const handleSort = (column, sortDirection) => {
    setSort(`${column.selector} ${sortDirection}`);
  };

  return (
    <ContentPanel title="Grupo de Usuário" message={message} actions={actions}>
      <DataTableReact
        noHeader
        columns={columns}
        data={dataUserGroup}
        pagination
        paginationServer
        progressComponent={<DataTableLoading />}
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer
        onSort={handleSort}
        paginationDefaultPage={filter.page}
      />
    </ContentPanel>
  )
}